import {
	IOnFailure,
	IOnSuccess,
	performWithCallbacks,
	withErrorLogger,
} from '@move-frontend/auth';
import log from 'loglevel';
import { cognitoClient } from '../../../../../shared/api/cognito';
import { ChangePasswordFormSchema } from './useChangePasswordSchema';

interface IUseChangePasswordProps {
	onSuccess: IOnSuccess<string>;
	onFailure: IOnFailure;
}

export const useChangePasswordSubmit = ({
	onSuccess,
	onFailure,
}: IUseChangePasswordProps) => {
	const changePassword = async (
		data: Omit<ChangePasswordFormSchema, 'confirmNewPassword'>,
	) => cognitoClient.changePassword(data.currentPassword, data.password);

	const performChangePassword = async (
		data: Omit<ChangePasswordFormSchema, 'confirmNewPassword'>,
	) =>
		performWithCallbacks(
			withErrorLogger(changePassword, { customLogError: log.error }),
			onSuccess,
			onFailure,
			data,
		);

	return {
		performChangePassword,
	};
};
